import { useContext } from "react";
import { SettingsContext } from "./Settings.context";

export default function useSettings() {
  return useContext(SettingsContext);
}